import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { SectionHeading } from '@/components/generals/section-heading'
import { BENEFITS } from '@/constants/content'

export const WhySection: FC = (): ReactNode => {
    return (
        <section id='why-roamwood' className='bg-secondary/60 py-20 lg:py-28'>
            <div className='mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20'>
                <div className='relative'>
                    <div className='relative aspect-[4/3] overflow-hidden rounded-[2rem] bg-secondary lg:aspect-[5/6]'>
                        <Image
                            src='/images/workshop.jpg'
                            alt="Timber workbench with a hand plane, saw and measuring tools in a sunlit workshop"
                            fill
                            sizes='(min-width: 1024px) 50vw, 100vw'
                            className='object-cover'
                        />
                    </div>

                    <div className='absolute -bottom-6 left-6 rounded-2xl bg-forest px-6 py-5 text-forest-foreground shadow-xl sm:left-10'>
                        <p className='font-heading text-3xl font-medium'>
                            100%
                        </p>

                        <p className='mt-1 text-sm text-forest-foreground/75'>
                            built in our own workshop
                        </p>
                    </div>
                </div>

                <div>
                    <SectionHeading
                        eyebrow="Why Roamwood"
                        title="Built like a real home, because it is one"
                        description="A tiny house has to handle the road, the weather and everyday life. We build ours with the same care, materials and standards as a full-size timber home."
                    />

                    <div className='mt-12 grid gap-x-8 gap-y-10 sm:grid-cols-2'>
                        {BENEFITS.map(benefit => (
                            <div key={benefit.title}>
                                <span className='flex size-12 items-center justify-center rounded-xl bg-background text-primary shadow-sm'>
                                    <benefit.icon className='size-6' aria-hidden='true' />
                                </span>

                                <h3 className='mt-5 text-lg font-semibold'>
                                    {benefit.title}
                                </h3>

                                <p className='mt-2 leading-relaxed text-muted-foreground'>
                                    {benefit.text}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
